import { render } from "./EmptyState.vue?vue&type=template&id=fdf9fc60&scoped=true&ts=true"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"

import "./EmptyState.vue?vue&type=style&index=0&id=fdf9fc60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf9fc60"]])

export default __exports__